import script from "./GenerateResultSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateResultSection.vue?vue&type=script&setup=true&lang=js"

import "./GenerateResultSection.vue?vue&type=style&index=0&id=608be207&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608be207"]])

export default __exports__